module.exports = __webpack_public_path__ + "static/media/libi-login.9c53af4b.png";